var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"Button",class:_vm.className,on:{"click":_vm.onclick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }